import React from 'react';
import { Modal, Checkbox, Row, Col, Button, Icon } from 'antd';
import {Typography} from '@/components';
import * as R from 'ramda';

export interface TransferProps {
  visible?: boolean,
  onOk?: () => void,
  onCancel?: () => void,
  title?: string,
  onChange?: (e: any) => void,
  dataSource: any[]
}

export interface CheckBoxListProps<D> {
  dataSource: D []
  onChange?: (e: any) => void,
}

const CheckBoxList: React.FC<CheckBoxListProps<any>> = props => {
  
  const {onChange,dataSource} = props;
  
  
  return (
    <Checkbox.Group value={[]} style={{width: '100%'}} onChange={onChange}>
      <Row gutter={[16, 16]} type='flex' style={{flexWrap: 'wrap', width: '100%'}}>
        {dataSource.map(item =>
          <Col key={item.id} span={4}>
            <Checkbox value={item.id}>{item.name}</Checkbox>
          </Col>)}
      </Row>
    </Checkbox.Group>
  )
}

const ButtonList: React.FC<CheckBoxListProps<any>> = props => {
  
  const {dataSource, onChange} = props;
  
  const handleButton = (data: {name: string, id: number}) => {
    // @ts-ignore
    onChange({
      id: data.id,
      name: data.name,
      type: 'delete'
    })
  }
  
  return (
    <Row style={{backgroundColor: 'rgba(0,0,0,0.02)'}} type='flex' gutter={[16, 16]}>
      {dataSource.map(item =>
        <Col key={item.id} span={4}>
          <Button data-key={item.id} onClick={() => handleButton(item)}>{item.name}
            <Icon type="close" />
          </Button>
        </Col>
      )}
    </Row>
  )
  
}

const ModalTransfer: React.FC<TransferProps> = props => {
  
  const {visible, onOk, onCancel, title, dataSource, onChange} = props;
  
  const handleCheckBox = (value: number[]) => {
  
    const isEven = (n: {id: number}) => n.id === value[value.length -1];
  
    const data: any = R.filter(isEven, dataSource[0].concat(dataSource[1]))[0]
  
    // @ts-ignore
    value = value[value.length -1]
    console.log(data);
    // @ts-ignore
    onChange({
      id: data.id,
      name: data.name,
      type: 'add'
    })
  }
  
  return (
    <Modal
      title={title}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={1100}
    >
      <Row  gutter={[16, 36]}>
        <Col>
          <Typography.Title level={3}>已安装应用（{dataSource[0].length}个）</Typography.Title>
          <ButtonList onChange={onChange} dataSource={dataSource[0]} />
        </Col>
        <Col span={24}>
          <Typography.Title level={3}>未安装应用（{dataSource[1].length}个）</Typography.Title>
          <CheckBoxList onChange={handleCheckBox} dataSource={dataSource[1]} />
        </Col>
      </Row>
    </Modal>
  )
  
}

ModalTransfer.defaultProps = {
  visible: true,
  onOk: () => {},
  onCancel:  () => {},
  title: '弹窗',
  dataSource: [],
}

export default ModalTransfer;
